import { UPDATE_SERVICE_REQUEST} from "../actionTypes";
import { UpdateServiceRequest } from "../../../api/newService/updateService.service";

const request = () => ({ type: UPDATE_SERVICE_REQUEST.REQUEST });
const failure = (error) => ({ type: UPDATE_SERVICE_REQUEST.FAILURE, error });
const success = () => ({ type: UPDATE_SERVICE_REQUEST.SUCCESS });

export const SubmitUpdateRequst = (payload,id) => {
  return (dispatch, getState) => {
    dispatch(request());
    return UpdateServiceRequest(payload,id)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false,code:error?.code,});
      });
  };
};
